'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import f from "../Form/InputNumber.js";
import g from "../../external/classnames/index.js";
import d from "./bmi-calculator.module.scss.js";
import { useState as u, useCallback as p, useEffect as m } from "react";
import I from "../Button/Button.js";
import B from "../AdvancedAccordion/index.js";
import { useTheme as k } from "../Provider/index.js";
const x = {
  wrapper: {
    className: "w-full flex justify-center"
  },
  label: {
    className: "pl-1 order-last text-regular pt-4 text-center"
  },
  input: {
    className: "focus:outline-none bg-white w-full text-md active:border-b text-center"
  }
}, M = [
  {
    title: "What is BMI?",
    isTitleBolded: !1,
    content: "Body mass index, or BMI, is used to determine whether you are in a healthy weight range for your height. It is useful to consider your waist circumference as well as your BMI."
  }
], y = {
  Underweight: /* @__PURE__ */ e.jsx("ul", { className: "list-disc ml-4", children: /* @__PURE__ */ e.jsx("li", { children: "You are underweight for your height. It's important to stay within a healthy weight range to improve your body's ability to fight off illness or infections." }) }),
  Normalweight: /* @__PURE__ */ e.jsx("ul", { className: "list-disc ml-4", children: /* @__PURE__ */ e.jsx("li", { children: "You are a healthy weight for your height. It's important to aim to stay within the healthy weight range by maintaining a well-balanced diet and exercising regularly." }) }),
  Overweight: /* @__PURE__ */ e.jsxs("ul", { className: "list-disc ml-4", children: [
    /* @__PURE__ */ e.jsx("li", { children: "Your BMI is considered overweight for your height. It’s also recommended to check your waist measurement. Being overweight increases your risk of a number of health conditions such as coronary heart disease or type 2 diabetes." }),
    /* @__PURE__ */ e.jsx("li", { children: "To achieve and maintain a healthy weight, it’s important to enjoy a healthy, well-balanced diet and exercise regularly." }),
    /* @__PURE__ */ e.jsx("li", { children: "For specific medical and dietary advice, consult your doctor or an Accredited Practising Dietitian." })
  ] }),
  Obese: /* @__PURE__ */ e.jsx("ul", { className: "list-disc ml-4", children: /* @__PURE__ */ e.jsx("li", { children: "Your BMI is considered obese for your height. It's also recommended to check your waist measurement. As your BMI increases, so does the risk of developing serious health conditions such as coronary heart disease, type 2 diabetes and osteoarthritis." }) })
}, S = ({
  ctaLabel: r = "Get started",
  headingText: i = "Calculate your BMI",
  descriptionText: n = "Calculate your Body Mass Index (BMI) to determine if you are in a healthy weight range for your height.",
  accordionData: t = M,
  results: c = y,
  route: o,
  onClick: l,
  textColor: a = "green-dark",
  bgColor: h,
  activeColor: w,
  ...j
}) => {
  const [b, N] = u(0);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      ...j,
      className: g(
        d["bmi-calculator"],
        `bg-${h} p-2 gap-1`
      ),
      children: [
        /* @__PURE__ */ e.jsx("h2", { className: `text-center text-${a}`, children: i }),
        " ",
        /* @__PURE__ */ e.jsxs("div", { className: "mx-auto max-w-md", children: [
          /* @__PURE__ */ e.jsx("p", { className: `text-center text-${a} pb-4`, children: n }),
          /* @__PURE__ */ e.jsx(R, { bmiResult: (v) => N(v) }),
          /* @__PURE__ */ e.jsx(
            C,
            {
              bmi: b,
              ctaLabel: r,
              resultsContent: c,
              route: o,
              onClick: l,
              textColor: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            B,
            {
              items: t,
              textColor: a,
              bgColor: h,
              activeColor: w
            }
          )
        ] })
      ]
    }
  );
}, R = ({ bmiResult: r }) => {
  const [i, n] = u(""), [t, c] = u(""), [o, l] = u(0), a = p(() => {
    i && t && l(
      parseInt(i) / (parseInt(t) * parseInt(t) / 1e4)
    );
  }, [i, t]);
  return m(() => {
    a();
  }, [a]), m(() => {
    r(o);
  }, [o, r]), /* @__PURE__ */ e.jsx("form", { className: g(d["bmi-calculator--form"]), children: /* @__PURE__ */ e.jsxs("div", { className: "mb-6 flex w-full flex-nowrap space-x-4", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "w-1/2 rounded-lg border-2 bg-white p-2 leading-tight text-black md:p-4 ", children: [
      /* @__PURE__ */ e.jsx("p", { className: "mb-2 text-left text-regular text-black", children: "Your height" }),
      /* @__PURE__ */ e.jsx(
        f,
        {
          label: "cm",
          placeholder: " ",
          id: "bmi-calculator-cm",
          style: x,
          value: t,
          onValueChange: (h) => c(h || "")
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "w-1/2 rounded-lg border-2 bg-white p-2 leading-tight text-black md:p-4 ", children: [
      /* @__PURE__ */ e.jsx("p", { className: "mb-2 text-left text-regular text-black", children: "Your weight" }),
      /* @__PURE__ */ e.jsx(
        f,
        {
          label: "kg",
          placeholder: " ",
          id: "bmi-calculator-kg",
          style: x,
          value: i,
          onValueChange: (h) => n(h || "")
        }
      )
    ] })
  ] }) });
}, s = (r, i, n) => r >= i && r <= n, Y = (r) => s(r, 0, 10) ? "Please enter your weight and height as accurate as possible" : s(r, 11, 17.9) ? "Underweight" : s(r, 18, 25.9) ? "Normal weight" : s(r, 26, 29.9) ? "Overweight" : s(r, 30, 60) ? "Obese" : "Please enter your weight and height as accurate as possible", A = (r, i, n) => (r - i) * 100 / (n - 10), C = ({
  bmi: r,
  ctaLabel: i,
  resultsContent: n = y,
  route: t,
  onClick: c,
  textColor: o = "green-dark"
}) => {
  const l = Y(r), a = s(r, 11, 60), { isMoshy: h } = k();
  return /* @__PURE__ */ e.jsxs(
    "article",
    {
      className: g(d["bmi-calculator--results"], {
        [`text-${o}`]: o
      }),
      children: [
        /* @__PURE__ */ e.jsxs("header", { children: [
          a ? "" : /* @__PURE__ */ e.jsx("span", { children: l }),
          a,
          a && /* @__PURE__ */ e.jsxs("p", { className: `text-center text-${o}`, children: [
            "Your BMI is considered",
            /* @__PURE__ */ e.jsx("br", {}),
            /* @__PURE__ */ e.jsxs("span", { className: "mt-2 block font-body text-lg", children: [
              l,
              " ",
              /* @__PURE__ */ e.jsxs("span", { className: "font-body text-md text-grey ", children: [
                "(",
                r.toFixed(1),
                ")"
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(O, { bmi: r })
        ] }),
        /* @__PURE__ */ e.jsx("main", { "data-results-valid": a, children: n[l.replace(/\s/g, "")] }),
        (l === "Overweight" || l === "Obese") && /* @__PURE__ */ e.jsxs("footer", { className: "p-4 text-center text-green-dark", children: [
          /* @__PURE__ */ e.jsx("p", { className: "mb-4 font-bolder", children: h ? "You may be eligible for Moshy's weight loss program" : "You may be eligible for Mosh's weight loss program" }),
          /* @__PURE__ */ e.jsx(
            I,
            {
              text: i,
              as: "a",
              href: t,
              onClick: c
            }
          )
        ] })
      ]
    }
  );
}, O = ({ bmi: r }) => {
  const [i, n] = u(0), t = Math.round(A(r, 10, 40)), c = p(() => s(t, 0, 5) ? 1 : s(t, 6, 15.9) ? 2 : s(t, 16, 20.9) ? 3 : s(t, 21, 25.9) ? 4 : s(t, 26, 30.9) ? 5 : s(t, 31, 35.9) ? 6 : s(t, 36, 40.9) ? 7 : s(t, 41, 50.9) ? 8 : s(t, 51, 55.9) ? 9 : s(t, 56, 60.9) ? 10 : s(t, 61, 64.9) ? 11 : s(t, 65, 75.9) ? 12 : s(t, 76, 79.9) ? 13 : s(t, 80, 83.9) ? 14 : s(t, 84, 89.9) ? 15 : s(t, 90, 100) || r > 40 ? 16 : 0, [t, r]);
  m(() => {
    n(c());
  }, [c]);
  const o = (l) => s(l, 0, 3) ? "underweight" : s(l, 4, 7) ? "normal" : s(l, 8, 11) ? "overweight" : s(l, 12, 15) ? "obese" : null;
  return /* @__PURE__ */ e.jsx(
    "ul",
    {
      className: d["bmi-calculator--range"],
      "data-range-active": i,
      children: Array(16).fill(0).map((l, a) => /* @__PURE__ */ e.jsx(
        "li",
        {
          "data-range-index": a + 1,
          "data-range": o(a),
          "data-active": a + 1 === i && !0,
          children: /* @__PURE__ */ e.jsx(P, {})
        },
        a + 1
      ))
    }
  );
}, P = () => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M4.13397 7.5C4.51887 8.16667 5.48113 8.16667 5.86603 7.5L9.33013 1.5C9.71503 0.833334 9.2339 0 8.4641 0H1.5359C0.766098 0 0.284973 0.833333 0.669873 1.5L4.13397 7.5Z",
        fill: "#82C780"
      }
    )
  }
);
export {
  S as default
};
